<template>
  <div v-if="!loading">
    <h5 v-if="title">{{title}}</h5>
    <p>
      <slot />
    </p>
  </div>
</template>


<script>
export default {
  name: 'OverviewBoxGroup',
  props: {
    title: String
  },
  computed: {
    loading() {     
      var loadingComponent = this.findLoadingParent(this.$parent)
      if(loadingComponent)
        return loadingComponent.$props.loading

      return false
    }
  },
  methods: {
    // Recursively find the parent 'ContentBox' or 'TabbedBox' components for the data item
    // Checks the parent's loading prop
    findLoadingParent(comp) {
      if(comp == null)
        return null
      if(comp.$options.name == 'OverviewBox')
        return comp

      return this.findLoadingParent(comp.$parent)
    }
  }
};
</script>